export default function renderProductSlider() {
  $('.abgne-yahoo-carousel').each(function () {
    // �����o�����������μe�׵����
    var $this = $(this),
      $page = $this.find('.page'),
      $btn = $this.find('.btn'),
      _frameWidth = $this.find('.frame').width(),
      $carousel = $this.find('ul'),
      $items = $carousel.find('li'),
      _itemLength = $items.length, // 9
      _set = Math.floor(_frameWidth / $items.outerWidth(true)), //1170/270  290? = 4
      _count = Math.ceil(_itemLength / _set),  // 9 / 4  = 3
      _width = _set * $items.outerWidth(true) * -1,
      _speed = 400, _opacity = 0.75, _index = 0
    // �Ψ���ܥثe�w��ܤ��`��Ƶ��Ƹ�T
    $page.html('1 - ' + (_set < _itemLength ? _set : _itemLength) + ' / ' + _itemLength)  // 1-4/9 = 5/9

    // ���C�@�� li �[�W���D�ξB�n
    $items.each(function () {
      // var $this = $(this),
      // _href = $this.find('a').attr('href')
      // _title = $this.find('img').attr('title')

      // $this.append('<div class="ovrly"></div>' +
      //     '<h3>' +
      //     '<a href="' + _href + '" alt="' + _title + '" title="' + _title + '">' + _title + '</a>' +
      //     '</h3>').find('.ovrly').css('opacity', _opacity)
    })

    // ����F�W�U�������s��
    $btn.find('.prev, .next').click(function (e) {
      // �p��n��ܲĴX��
      _index = Math.floor((e.target.className === 'prev' ? _index - 1 + _count : _index + 1) % _count)
      var _lastNum = _set * (_index + 1)
      $page.html((_set * _index + 1) + ' - ' + (_lastNum < _itemLength ? _lastNum : _itemLength) + ' / ' + _itemLength)
      // �i��ʵe
      $carousel.stop().animate({
        left: _index * _width
      }, _speed)

      e.preventDefault()
    }).focus(function () {
      this.blur()
    })
  })
}



// WEBPACK FOOTER //
// ./src/libs/jquery.product_slider.js